"use client"

import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import 'react-phone-input-2/lib/style.css';

const PhoneInput = dynamic(() => import('react-phone-input-2'), {
  ssr: false,
});

const normalizePhoneNumber = (phoneNumber) => {
  const digitsOnly = (phoneNumber ?? '').replace(/[^0-9]+/g, '');

  if (!digitsOnly) {
    return '';
  }

  if (digitsOnly.length === 10 && !digitsOnly.startsWith('1')) {
    return `1${digitsOnly}`;
  }

  return digitsOnly;
};

const PhoneInputWrapper = ({ onChange, value, ...props }) => {
  const normalizedValue = normalizePhoneNumber(value);

  useEffect(() => {
    if (typeof onChange !== 'function') {
      return;
    }

    if ((value ?? '') !== normalizedValue) {
      onChange(normalizedValue);
    }
  }, [onChange, normalizedValue, value]);

  const handleChange = (nextValue, country, event, formattedValue) => {
    if (typeof onChange !== 'function') {
      return;
    }

    onChange(normalizePhoneNumber(nextValue), country, event, formattedValue);
  };

  return (
    <PhoneInput
      {...props}
      value={normalizedValue}
      onChange={handleChange}
      country={"us"}
      onlyCountries={["us"]}
      disableDropdown={true}
    />
  );
};

export default PhoneInputWrapper;